<style>
  div.header {
    max-width: 500px;
    min-width: 320px;
    display: grid;
    grid-template-columns: 35% 15% 30% 17%;
    grid-template-rows: 35px;
  }
  h3.header {
    width: 100%;
    font-family: cursive;
    text-align: center;
    margin: auto;
  }
  .menu {
    padding-top: 8px;
    font-size: 12px;
    font-weight: bold;
  }

  .menu:hover {
    color: blue;
  }
  .statistics {
    padding-left: 10px;
  }

  @media (min-width: 500px) {
    .menu {
      display: inline;
      padding-top: 10px;
      text-align: right;
      font-size: 12px;
      font-weight: 600;
    }
  }
</style>

<script>
  import { setContext } from 'svelte'
  import {
    gameScore,
    startNextHand,
    restartGame,
    updateGameScore,
  } from './stores/cards'
  import Game from './components/Game.svelte'
  import Modal from './components/Modal.svelte'
  import ModalContact from './components/ModalContact.svelte'
  import ModalHelp from './components/ModalHelp.svelte'
  //import ModalSettings from './components/ModalSettings.svelte'
  import Button from './components/Button.svelte'

  import {
    getStatistics,
    updateStatistics,
    resetStatistics,
    getScores,
    updateScores,
    resetScores,
    getPoints,
    setPoints,
    getSpeed,
    setSpeed,
  } from './components/storage.js'

  let gamesPlayed, gamesWon, gamesLost, gamesTied
  let loadModal = ''
  let points = 0
  let speed
  let handOver = false
  let gameOver = false
  let stats = getStatistics()

  let playerHand, computerHand, gamePlayer, gameComputer

  setContext('end', {
    hand: endHand,
    nextHand: nextHand,
    game: endGame,
    nextGame: nextGame,
  })

  setContext('saveConfig', handleSave)

  setContext('close', closeModal)

  function handleSave() {
    setPoints(points)
    setSpeed(speed)

    loadModal = ''
  }

  function closeModal() {
    loadModal = ''
  }

  function endHand(scores) {
    console.log('endHand', scores)
    handOver = true
    updateScores({
      playerHand: scores.playerHand,
      computerHand: scores.computerHand
    }) // Local storage
    updateGameScore(scores) // game store
    //loadModal = 'stats'
  }

  function endGame(scores) {
    let newStats
    let score
    handOver = true
    gameOver = true
    playerHand = scores.playerHand
    computerHand = scores.computerHand
    console.log('endGame', scores)

    const unsubscribe = gameScore.subscribe(value => {
      score = value
    })
    unsubscribe()
    if (score.playerHand < score.computerHand) {
      newStats = {
        gamesPlayed: stats.gamesPlayed + 1,
        gamesWon: stats.gamesWon + 1,
        gamesLost: stats.gamesLost,
        gamesTied: stats.gamesTied,
      }
    } else if (score.playerHand < score.computerHand) {
      newStats = {
        gamesPlayed: stats.gamesPlayed + 1,
        gamesWon: stats.gamesWon,
        gamesLost: stats.gamesLost + 1,
        gamesTied: stats.gamesTied,
      }
    } else {
      newStats = {
        gamesPlayed: stats.gamesPlayed + 1,
        gamesWon: stats.gamesWon,
        gamesLost: stats.gamesLost,
        gamesTied: stats.gamesTied + 1,
      }
    }
    updateStatistics(newStats)
    scores.playerHand = 0
    scores.computerHand = 0
    // loadModal = 'stats'

    resetScores()
  }

  function reset() {
    resetStatistics()
  }

  function nextGame() {
    // handOver = false
    // gameOver = false
    restartGame()
  }

  function nextHand() {
    handOver = false
    startNextHand()
  }

  function cancelModal() {
    handOver = false
    gameOver = false
  }

  function menuClicked(name) {
    loadModal = name
  }

  function contactClicked() {
    loadModal = 'contact'
  }

  function settingsClicked() {
    loadModal = 'settings'
  }

  function closeScores() {
    handOver = false
  }
</script>

<div class="header">
  <div>
    <h3 class="header">Nine-Down</h3>
  </div>
  <div
    class="menu"
    style="padding-left: 5px"
    on:click="{() => menuClicked('help')}"
  >
    Help
  </div>
  <div class="menu" on:click="{() => menuClicked('contact')}">
    Contact/Donate
  </div>
</div>
<Game
  {speed}
  gamePoints="{points}"
  on:endGame="{endGame}"
  on:endHand="{endHand}"
/>

{#if loadModal === 'help'}
  <ModalHelp title="Nine-Down Play" on:exit="{closeModal}">
    <div>Help</div>
  </ModalHelp>
{:else if loadModal === 'contact'}
  <ModalContact title="Contact" on:exit="{closeModal}">
    <div>Contact</div>
  </ModalContact>
{:else if loadModal === 'stats'}
  <Modal title="Game Over" on:exit="{closeModal}">
  </Modal>
{/if}
